import { CountryCodes, Market } from '@bridebook/toolbox/src/gazetteer';
import type { Slug, UrlFriendlySlug } from '@bridebook/toolbox/src/types';
import { prettySupplierCategory } from '@bridebook/web/app-shared/lib/utils';

export const getPrettySupplierCategory = (
  slug: Slug | UrlFriendlySlug | '',
  market: Market,
  isLoggedIn: boolean,
) =>
  prettySupplierCategory({
    slug,
    amount: 2,
    addWedding: true,
    capitalize: market.country !== CountryCodes.FR,
    market,
    isLoggedIn,
  });
